import { get } from './requests'

export const getReasons = key => get(['reasons-to-cancel/?reason'], { key, transformPayload: true })

export const getReasonsToRefuseServiceOrder = key => get(['reasons-to-refuse'], { key })
